const isNestedActionResponse = response => !!response && 'action' in response;

export function transformPaymentAuthAction(_ref) {
  let {
    adyen,
    adyen_bank
  } = _ref;
  return {
    adyen: isNestedActionResponse(adyen) ? adyen.action : adyen,
    adyenBank: isNestedActionResponse(adyen_bank) ? adyen_bank.action : adyen_bank
  };
}